export const localStorageKeys = {
  JWT: "WT_TOKEN",
  clientId: "WT_CI",
  user: "WT_USER",
  auth: "WT_AUTH",
  showUpdatesModal101: "WT_UPDATEMODAL",
  sessionExpired: "WT_SESSIONEXPIRED",
};
